<template>
    <div class="menu-second">
        <div class="menu-second">
            <div class="menu-title">
                <span>优惠券</span>
            </div>
            <div class="menu-list">
                <div class="menu-item">
                    <router-link class="menu-item_title" :to="{path: '/app/coupon/list.html'}">优惠券列表</router-link>
                </div>
                <div class="menu-item">
                    <router-link class="menu-item_title" :to="{path: '/app/coupon/receive/list.html'}">领取记录</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "left"
    }
</script>

<style scoped>

</style>
